import { inject, injectable } from 'inversify';
import { RpcSuccess } from '@dealroadshow/json-rpc-dispatcher';
import Request from '@framework/api/Rpc/Request';
import { type IDispatcher } from '@creditflowresearch/json-rpc-dispatcher/dispatcher-cfr';
import DITypes from '@creditflowresearch/json-rpc-dispatcher/dispatcher-cfr/DITypes';
import BaseRepository from '@/creditflowresearch/infrastructure/repository/BaseRepository';

@injectable()
class ResearchRepository extends BaseRepository {
  constructor(
    @inject(DITypes.JsonRpcDispatcher) protected readonly rpc: IDispatcher,
  ) {
    super(rpc);
  }

  getResearchTileData = async (payload) => this.abortableCall(
    new Request('finsight_web.frontend.research.get_research_tile_data', payload),
  );

  getResearchList = async (payload) => this.abortableCall(
    new Request('finsight_web.research.get_research_list', payload),
  );

  getResearchDocument = async (id) => {
    const request = new Request('finsight_web.research.get_research_document', { id });
    const response = await this.rpc.call<RpcSuccess>(request);

    return response.getResult().payload;
  };

  getResearchFilter = async (payload) => {
    const request = new Request('finsight_web.research.filter.boundary', payload);
    const response = await this.rpc.call<RpcSuccess>(request);

    return response.getResult().payload;
  };

  getResearchFilterByHash = async (hash: string) => {
    const request = new Request('finsight_web.research.filter.get_by_hash', { hash });
    const response = await this.rpc.call<RpcSuccess>(request);

    return response.getResult().payload;
  };
}

export default ResearchRepository;
